import { ReactNode } from "react";
import { SelectOption } from "./types";

export function unitLabel(
  unitType: UnitType | undefined,
  unitValue: string | null | undefined,
): ReactNode {
  if (!unitType || !unitValue) return null;
  return unitOptions[unitType].find((o) => o.value === unitValue)?.label;
}

export type UnitType =
  | "length"
  | "weight"
  | "time"
  | "currency"
  | "area"
  | "power"
  | "pressure";
export const unitOptions: Record<UnitType, SelectOption[]> = {
  length: [
    { label: "in", value: "in" },
    { label: "mm", value: "mm" },
  ],
  weight: [
    { label: "g", value: "g" },
    { label: "kg", value: "kg" },
    { label: "lb", value: "lb" },
  ],
  time: [
    { label: "sec", value: "s" },
    { label: "min", value: "min" },
    { label: "h", value: "h" },
    { label: "day", value: "day" },
    { label: "week", value: "week" },
    { label: "month", value: "month" },
    { label: "year", value: "year" },
  ],
  currency: [{ label: "$", value: "USD" }],
  power: [{ label: "kW", value: "kW" }],
  pressure: [{ label: "kPSI", value: "kPSI" }],
  area: [
    {
      label: (
        <span>
          mm<sup>2</sup>
        </span>
      ),
      value: "mm2",
    },
    {
      label: (
        <span>
          in<sup>2</sup>
        </span>
      ),
      value: "in2",
    },
  ],
};
